export const TECHNICAL_INTERVENTIONS_DOMAIN_KEY = 'technicalInterventions';

export enum TECHNICAL_INTERVENTIONS_DOMAIN {
  list = 'list',
}
